import Swiper from '../../../../node_modules/swiper/swiper-bundle.mjs';

export const initHeroSlider = function() {
  const sliderHero = document.querySelector('[data-slider-hero="slider"]');

  if (!sliderHero) {
    return;
  }
  const sliderHeroPagination = sliderHero.querySelector('[data-slider-hero="pagination"]');

  function addZero(index) {
    let i = index + 1;
    return (
      i > 9
    ) ? i : '0' + i;
  }

  const swiperHero = function() {
    new Swiper(sliderHero, {
      effect: 'fade',
      autoHeight: true,
      autoplay: {
        delay: 5000
      },
      fadeEffect: {
        crossFade: true
      },
      slidesPerView: 1,
      pagination: {
        el: sliderHeroPagination,
        clickable: true,
        renderBullet: function(index, className) {
          return `<button class="slider__pagination-bullet ${className}" type="button" aria-label="Слайд №${index + 1}"></button>`;
        }
      },

      breakpoints: {
        768: {
          pagination: {
            el: sliderHeroPagination,
            clickable: true,
            renderBullet: function(index, className) {
              return `<button class="slider__pagination-bullet ${className}"  type="button">${addZero(index)}</button>`;
            }
          }
        }
      },
      on: {
        init: function() {
          if (sliderHero.clientWidth < sliderHeroPagination.scrollWidth) {
            sliderHeroPagination.classList.add('is-hidden');
          }
        }
      }
    });
  }

  swiperHero();

  const numSlide = sliderHero.querySelectorAll('.slider__slide');
  if (numSlide.length > 4) {
    sliderHero.classList.add('slider__swiper--horizont');
  }
};
